import { useEffect, useState } from "react";
import api, { managerApi } from "../services/api";
import ManagerLoginModal from "../components/ManagerLoginModal";
import { useRef } from "react";

export default function CashierPending() {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
const [closingOrders, setClosingOrders] = useState([]);
const closingRef = useRef([]);

  const [managerVerified, setManagerVerified] = useState(false);
  const [showManagerLogin, setShowManagerLogin] = useState(false);

  const [tenders, setTenders] = useState([]);
  const [tenderId, setTenderId] = useState("");
  const [payments, setPayments] = useState([]);

  const [discountType, setDiscountType] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [closing, setClosing] = useState(false);


  // 🔥 BACKEND SOURCE OF TRUTH
  const [finalAmount, setFinalAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);

  
  useEffect(() => {
  loadPendingOrders();
  loadTenders();

  const timer = setInterval(() => {
    loadPendingOrders();
  }, 4000);

  return () => clearInterval(timer);
}, []);



  const loadPendingOrders = async () => {
  const res = await api.get("/orders/pending");

  const filtered = res.data.filter(
    o => !closingRef.current.includes(o.live_order_id)
  );

  setOrders(filtered);
};



  const loadTenders = async () => {
    const res = await api.get("/config/init");
    setTenders(res.data.tenders);
  };

  // ================= SELECT ORDER =================
  const selectOrder = (order) => {
  localStorage.removeItem("manager_token");
  setManagerVerified(false);

  setSelectedOrder(order);
  setTenderId("");
  setPayments([]);
  setDiscountType("");
  setDiscountValue("");

  // Show loading state immediately
  setOrderItems([]);
  setFinalAmount(0);
  setDiscountAmount(0);

  api.get(`/orders/live/${order.live_order_id}`)
    .then(res => {
      setOrderItems(res.data.items || []);
      setFinalAmount(res.data.final_amount || 0);
      setDiscountAmount(res.data.discount_amount || 0);
    })
    .catch(() => {
      alert("Failed to load order details");
    });
};


  // ================= AMOUNTS =================
  const totalAmount = orderItems.reduce(
    (sum, i) => sum + (Number(i.price) || 0) * i.qty,
    0
  );

  const paidAmount = payments.reduce(
    (sum, p) => sum + Number(p.amount || 0),
    0
  );

  const isPaymentValid =
    payments.length > 0 &&
    Math.round(paidAmount) === Math.round(finalAmount);

  // ================= DISCOUNT =================
  const applyDiscount = async () => {
    if (!managerVerified) {
      setShowManagerLogin(true);
      return;
    }

    if (!discountType || !discountValue) {
      alert("Select discount type and value");
      return;
    }

    await managerApi.post(
      `/orders/${selectedOrder.live_order_id}/discount`,
      {
        type: discountType,
        value: discountValue
      }
    );

    // 🔄 reload backend truth
    const res = await api.get(
      `/orders/live/${selectedOrder.live_order_id}`
    );

    setOrderItems(res.data.items || []);
    setFinalAmount(res.data.final_amount || 0);
    setDiscountAmount(res.data.discount_amount || 0);

    setDiscountType("");
    setDiscountValue("");
    setPayments([]);
    setTenderId("");

    alert("Discount applied. Please reselect payment.");
  };

  // ================= CANCEL =================
  const cancelOrder = async () => {
  if (!managerVerified) {
    setShowManagerLogin(true);
    return;
  }

  const reason = prompt("Cancel reason");
  if (!reason) return;

  const orderId = selectedOrder.live_order_id;

  // 1️⃣ Remove instantly
  const removedOrder = orders.find(o => o.live_order_id === orderId);
  setOrders(prev => prev.filter(o => o.live_order_id !== orderId));
  setSelectedOrder(null);

  try {
    await managerApi.post(`/orders/${orderId}/cancel`, { reason });

  } catch (err) {
    // 2️⃣ Restore if failed
    setOrders(prev => [...prev, removedOrder]);
    alert("Cancel failed");
  }
};


  // ================= CLOSE =================
const closeOrder = async () => {
  if (!isPaymentValid) {
    alert("Select tender and ensure payment matches payable amount");
    return;
  }

  const orderId = selectedOrder.live_order_id;

  // 1️⃣ Add to closing block list
  setClosingOrders(prev => {
    const updated = [...prev, orderId];
    closingRef.current = updated;
    return updated;
  });

  // 2️⃣ Remove instantly from UI
  setOrders(prev =>
    prev.filter(o => o.live_order_id !== orderId)
  );

  setSelectedOrder(null);

  try {
    await api.post(`/orders/${orderId}/close`, { payments });

    // 3️⃣ Remove permanently from block list after success
    setClosingOrders(prev => {
      const updated = prev.filter(id => id !== orderId);
      closingRef.current = updated;
      return updated;
    });

  } catch (err) {
    alert(err.response?.data?.message || "Close failed");

    // 4️⃣ If failed → remove from block list so polling can show again
    setClosingOrders(prev => {
      const updated = prev.filter(id => id !== orderId);
      closingRef.current = updated;
      return updated;
    });

    loadPendingOrders();
  }
};



  return (
    <>
      <div style={{ display: "flex", padding: 20 }}>
        {/* LEFT */}
        <div style={{ flex: 1, maxWidth: "calc(100% - 440px)" }}>

          <h3>Pending Orders</h3>
          {orders.map(o => (
  <div
    key={o.live_order_id}
    onClick={() => selectOrder(o)}
    style={{
      padding: 10,
      border: "1px solid #ccc",
      marginBottom: 6,
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <span>
      Order #{o.order_no}
    </span>

    <span
  style={{
    padding: "2px 8px",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: "bold",
    color: "#fff",
    background:
      o.payment_status === "PAID" ? "#2e7d32" : "#ef6c00"
  }}
>
  {o.payment_status === "PAID" ? "PAID" : "PENDING"}
</span>

  </div>
))}

        </div>

        {/* RIGHT */}
<div
  style={{
    width: 420,        // 👈 receipt width
    marginLeft: 20,
    flexShrink: 0
  }}
>

  {selectedOrder && (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column"
      }}
    >

              <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px dashed #ccc",
    paddingBottom: 10,
    marginBottom: 10
  }}
>
  <strong style={{ fontSize: 18 }}>
    Order #{selectedOrder.order_no}
  </strong>

  <span
    style={{
      padding: "4px 10px",
      borderRadius: 12,
      fontSize: 12,
      color: "#fff",
      background:
        selectedOrder.payment_status === "PAID"
          ? "#16a34a"
          : "#f97316"
    }}
  >
    {selectedOrder.payment_status === "PAID"
      ? "PAID"
      : "PAY AT CLOSE"}
  </span>
</div>

              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
  {orderItems.map(i => (
    <div
      key={i.id}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px dashed #ddd",
        paddingBottom: 6
      }}
    >
      <div style={{ fontSize: 13 }}>
        {i.item_name}
        {i.size_name && ` (${i.size_name})`} × {i.qty}
      </div>

      <div style={{ fontWeight: "bold" }}>
        ₹{(i.price || 0) * i.qty}
      </div>
    </div>
  ))}
</div>


<div
  style={{
    marginTop: 12,
    borderTop: "2px solid #000",
    paddingTop: 10
  }}
>
  {/* ===== MANAGER DISCOUNT ===== */}
<div
  style={{
    marginTop: 10,
    paddingTop: 8,
    borderTop: "1px dashed #ccc"
  }}
>
  <div style={{ fontSize: 13, fontWeight: "bold", marginBottom: 6 }}>
    Manager Discount
  </div>

  <div style={{ display: "flex", gap: 6 }}>
    <select
      value={discountType}
      onChange={e => setDiscountType(e.target.value)}
      style={{ flex: 1 }}
    >
      <option value="">Type</option>
      <option value="VALUE">₹ Value</option>
      <option value="PERCENT">%</option>
    </select>

    <input
      type="number"
      placeholder="Amount"
      value={discountValue}
      onChange={e => setDiscountValue(e.target.value)}
      style={{ width: 90 }}
    />

    <button
      onClick={applyDiscount}
      style={{
        padding: "4px 10px",
        background: "#0f766e",
        color: "#fff",
        border: "none",
        borderRadius: 6,
        cursor: "pointer"
      }}
    >
      Apply
    </button>
  </div>
</div>

  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <span>Subtotal</span>
    <strong>₹{totalAmount}</strong>
  </div>

  {discountAmount > 0 && (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        color: "green"
      }}
    >
      <span>Discount</span>
      <strong>-₹{discountAmount}</strong>
    </div>
  )}

  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontSize: 18,
      marginTop: 6
    }}
  >
    <strong>Payable</strong>
    <strong>₹{finalAmount}</strong>
  </div>
</div>

              {/* PAYMENT */}
              <h4>Payment</h4>
              <select
                value={tenderId}
                onChange={e => {
                  setTenderId(e.target.value);
                  setPayments([
                    {
                      tender_id: Number(e.target.value),
                      amount: finalAmount
                    }
                  ]);
                }}
              >
                <option value="">Select Tender</option>
                {tenders.map(t => (
                  <option key={t.tender_id} value={t.tender_id}>
                    {t.tender_name}
                  </option>
                ))}
              </select>

              <br /><br />

<div style={{ marginTop: "auto" }}>
  {/* CLOSE ORDER */}
 <button
  onClick={closeOrder}
  disabled={closing || payments.length === 0}
  style={{
    width: "100%",
    padding: "14px",
    fontSize: 16,
    fontWeight: "bold",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    cursor: "pointer"
  }}
>
  {closing ? "Closing..." : "CLOSE ORDER"}
</button>


  {/* CANCEL ORDER */}
  <button
    onClick={cancelOrder}
    style={{
      width: "100%",
      marginTop: 8,
      padding: "10px",
      background: "#b00020",
      color: "#fff",
      border: "none",
      borderRadius: 10,
      cursor: "pointer",
      fontSize: 14
    }}
  >
    CANCEL ORDER
  </button>
    </div>

    </div>
  )}
  </div>
</div>

      {showManagerLogin && (
        <ManagerLoginModal
          onSuccess={() => {
            setManagerVerified(true);
            setShowManagerLogin(false);
            alert("Manager verified. Apply discount again.");
          }}
          onClose={() => setShowManagerLogin(false)}
        />
      )}
    </>
  );
}
